import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import { colorStore } from './color.js'
import touchStart from '@mailobj-browser/front/js/events/types/touchStart.js'
import touchEnd from '@mailobj-browser/front/js/events/types/touchEnd.js'
import mouseDown from '@mailobj-browser/front/js/events/types/mouseDown.js'
import mouseMove from '@mailobj-browser/front/js/events/types/mouseMove.js'
import mouseUp from '@mailobj-browser/front/js/events/types/mouseUp.js'
import mouseOut from '@mailobj-browser/front/js/events/types/mouseOut.js'
import { globals } from '#utilities/js/ea/ea.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import { helpers } from '#components/generics/js/styles.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'

let currentX = 0
let currentY = 0
let isDrawing = false
const cases = object(null, {
  pencil: ({ context, canvas, event, selectedSize, selectedColor }) => {
    context.lineWidth = selectedSize
    context.lineCap = 'round'
    context.strokeStyle = selectedColor
    context.moveTo(currentX, currentY)
    setMousePos(canvas, event)
    context.lineTo(currentX, currentY)
    context.stroke()
  },
  paint: ({ context, canvas, event, selectedSize, selectedColor }) => {
    const d = context.getImageData(currentX, currentY, 1, 1)
    console.log(d, d.data[0], d.data[1], d.data[2])
  },
  eraser: () => {

  },
  line: () => {

  },
  filledRect: () => {

  },
  emptyRect: () => {

  },
  filledSquare: () => {

  },
  emptySquare: () => {

  },
  filledEllipse: () => {

  },
  emptyEllipse: () => {

  },
  filledCircle: () => {

  },
  emptyCircle: () => {

  },
  pipette: () => {

  },
  undo: () => {

  },
  clear: () => {

  }
})

const setMousePos = (canvas, event) => {
  const { left, top } = canvas.getBoundingClientRect()
  const { clientX, clientY } = event

  currentX = clientX - left
  currentY = clientY - top
}

export const init = (wrapper) => {
  const canvas = one(`.${helpers.xfiles.elements.xfiles_attach_draw_canvas}`, wrapper)

  if (canvas) {
    reset(canvas)

    colorStore(wrapper)

    onTouchStart.listen(canvas)
    onTouchEnd.listen(canvas)
    onMouseDown.listen(canvas)
    onMouseMove.listen(canvas)
    onMouseUp.listen(canvas)
    onMouseOut.listen(canvas)
  }
}

const onMouseDown = object(listener, {
  type: mouseDown,
  passive,
  task: (
    canvas,
    event
  ) => {
    updateCursorPosition(canvas, event)
  }
})

const onMouseMove = object(listener, {
  type: mouseMove,
  passive,
  task: (
    canvas,
    event
  ) => {
    updateCursorPosition(canvas, event)
  }
})

const onMouseUp = object(listener, {
  type: mouseUp,
  passive,
  task: (
    canvas,
    event
  ) => {
    updateCursorPosition(canvas, event)
  }
})

const onMouseOut = object(listener, {
  type: mouseOut,
  passive,
  task: (
    canvas,
    event
  ) => {
    updateCursorPosition(canvas, event)
  }
})

const onTouchStart = object(listener, {
  type: touchStart,
  passive,
  task: (
    canvas,
    event
  ) => {
    updateCursorPosition(canvas, event)
  }
})

const onTouchEnd = object(listener, {
  type: touchEnd,
  passive,
  task: (
    canvas
  ) => {
    save(canvas)
  }
})

const reset = (canvas) => {
  const context = canvas.getContext('2d')

  if (context) {
    if (canvas.classList.contains(helpers.xfiles.elements.xfiles_attach_draw_canvas_drawn)) {
      canvas.classList.remove(helpers.xfiles.elements.xfiles_attach_draw_canvas_drawn)
    }
    context.beginPath()
    context.fillStyle = '#FFFFFF'
    context.fillRect(0, 0, canvas.width, canvas.height)
  }
}

const draw = (canvas, event) => {
  const context = canvas.getContext('2d')
  const container = closest(`.${helpers.xfiles.elements.xfiles_attach_draw}`, canvas)
  const { value: selectedColor } = one(`input[name='canvas_color_bkg']`, container)
  const { value: selectedSize } = one(`input[name='canvas_size']`, container)
  const { value } = one('[type="hidden"][name="canvas_tool"]', container)

  requestAnimationFrame(() => {
    if (!canvas.classList.contains(helpers.xfiles.elements.xfiles_attach_draw_canvas_drawn)) {
      canvas.classList.add(helpers.xfiles.elements.xfiles_attach_draw_canvas_drawn)
    }

    context.beginPath()
    cases[value]?.({ context, canvas, event, selectedSize, selectedColor })
  })
}

const save = (canvas) => {
  const { id } = canvas
  const wrapper = closest(`.${helpers.xfiles.elements.xfiles_attach_draw}`, canvas)
  let field
  let data

  globals.ea_canvas_set(0)
  globals.ea_canvas_save(id)

  if (wrapper) {
    field = one('[type="hidden"][name="upload_draw_data"]', wrapper)

    if (field) {
      data = canvas.toDataURL()

      if (data) {
        field.value = data
      }
    }
  }
}

const updateCursorPosition = (canvas, event) => {
  const { type } = event

  if (type === 'mousedown') {
    setMousePos(canvas, event)
    draw(canvas, event)
    isDrawing = true
  }

  if (type === 'mousemove' && isDrawing) {
    draw(canvas, event)
  }

  if (type === 'mouseup' || type === 'mouseout') {
    isDrawing = false
  }
}

export default wrapper => {}